/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListDirectoryReviewItems } from "../funcs/accessListDirectoryReviewItems.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListDirectoryReviewItemsResult } from "../models/components/listdirectoryreviewitemsresult.js";
import {
  ListDirectoryReviewItemsRequest,
  ListDirectoryReviewItemsSecurity,
} from "../models/operations/listdirectoryreviewitems.js";
import { unwrapAsync } from "../types/fp.js";
export type DirectoryReviewItemsQueryData = ListDirectoryReviewItemsResult;

export function prefetchDirectoryReviewItems(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListDirectoryReviewItemsRequest | undefined,
  security?: ListDirectoryReviewItemsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDirectoryReviewItemsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDirectoryReviewItemsQuery(
  client$: GramCore,
  request?: ListDirectoryReviewItemsRequest | undefined,
  security?: ListDirectoryReviewItemsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DirectoryReviewItemsQueryData>;
} {
  return {
    queryKey: queryKeyDirectoryReviewItems({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function directoryReviewItemsQueryFn(
      ctx,
    ): Promise<DirectoryReviewItemsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListDirectoryReviewItems(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDirectoryReviewItems(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listDirectoryReviewItems", parameters];
}
